import axios from 'axios'
//ตัวแปรกลาง (ใช้ทั้งระบบ)
export let materialList = []
export async function loadMaterialList(apiUrl, tax_id) {
  // โหลดแล้วไม่ต้องยิงซ้ำ
  const { data } = await axios.get(
    `${apiUrl}/gl_account/api/v1/search_gl_select`,
    {
      params: { tax_id }
    }
  )
  if (data.status) {
    materialList = data.data
  }
  return materialList
}
// reset กรณีเปลี่ยน biz / tax_id
export function clearMaterialList() {
  materialList = []
}